exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#subtitle-area[data-v-06752103] {\n  display: inline-block;\n  margin-right: 30px;\n}", ""]);

// exports
